module.exports = __webpack_public_path__ + "static/media/2.3b18046c.png";